import { render, staticRenderFns } from "./BankRemitCreatePage.vue?vue&type=template&id=573c8092&scoped=true&"
import script from "./BankRemitCreatePage.vue?vue&type=script&lang=ts&"
export * from "./BankRemitCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./BankRemitCreatePage.vue?vue&type=style&index=0&id=573c8092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c8092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VStepper,VStepperHeader,VStepperStep,VTooltip})
